import create from 'zustand'
import produce from 'immer'

export const NoticeStore = create((set) => ({
    notices: [],
    add: (item) => {
        set(
            produce((draft) => {
                draft.notices.unshift(item)
            }),
        )
    },
    remove: (number = 1) => {
        set(
            produce((draft) => {
                typeof number === 'number'
                    ? draft.notices.splice(0, number)
                    : draft.notices.splice(0, 1)
            }),
        )
    },
    skim: () => {
        set(
            produce((draft) => {
                draft.notices.shift()
            }),
        )
    },
    reset: () => {
        set({ notices: [] })
    },
}))
